/**
 * @description: 禁止特殊情况下发生滚动
 * @param {boolean} state
 * @return {*}
 */
export const overScrollHandler = (state: boolean) => {
  state ? (document.body.style.overflow = 'hidden') : document.body.style.removeProperty('overflow');
};

/**
 * @description: 复制
 * @param {string} copyValue
 * @return {*}
 */
export const copyHandler = (text: string) => {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    const oInput = document.createElement('input');
    oInput.value = text;
    document.body.appendChild(oInput);
    oInput.select();
    const successful = document?.execCommand('Copy');
    oInput.remove();
    return successful ? Promise.resolve() : Promise.reject();
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * @description:只支持数字输入
 * @param {string} str
 * @return {*}
 */
export const formatNumber = (str: string): string => {
  return str.replace(/\D/g, '');
};
